// Localização: src/Services/aiService.js
import axios from "axios";

const sendMessage = async (message, sessionId, token) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_AI_ROUTE}/api/chat/web`,
      {
        message: message,
        sessionId: sessionId, // 🔑 Enviado para contexto temporário
        origin: "plataforma",
      },
      {
        headers: {
          Authorization: `Bearer ${token}`, // 🔑 Segurança e identificação do cliente
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao enviar mensagem para IA:", error);
    throw error;
  }
};

export const aiService = {
  sendMessage,
};
